/*
*/
import { set } from 'dot-prop-immutable';
import { Action } from 'redux';
import {IIndexStateType} from '../typings/shared';

export enum GeneralActionTypes {
  UPDATE_CONTENT_LINK = 'UPDATE_CONTENT_LINK'
}

export interface IBaseAction<PAYLOAD_TYPE extends any, TYPE extends any> extends Action<TYPE> {payload: PAYLOAD_TYPE}

export interface GeneralActionType<VALUE_TYPE = any, TYPE = any> extends IBaseAction<{ path: string, value: VALUE_TYPE }, TYPE> { }

export interface GeneralUpdateAction<VALUE_TYPE = any> extends GeneralActionType<VALUE_TYPE, GeneralActionTypes.UPDATE_CONTENT_LINK> { }


export type GeneralActions = GeneralUpdateAction;

export const indexInitState: IIndexStateType = {
  id: "",
  term_id: "",
  version: "",
  files: null,
  content: ""
};

export default {
  actionTypes: GeneralActionTypes,
  actions: {
    getGeneralUpdateAction: (path: string, value: any): GeneralUpdateAction => {
      return {
        type: GeneralActionTypes.UPDATE_CONTENT_LINK,
        payload: {
          path, value
        }
      }
    }
  },
  reducer: (state = indexInitState, action: GeneralActions) => {
    if (!action.payload) { return state }
    let { path } = action.payload;
    let value: any;
    if ('value' in action.payload) {
      value = action.payload.value;
    }
    switch (action.type) {
      case GeneralActionTypes.UPDATE_CONTENT_LINK:
        if (typeof value == 'function') {
          let originalValue = value;
          value = (v: any) => {
            return originalValue(v, state);
          }
        }
        if(path){
          return set(state, path, value);
        }
        return Object.assign({}, state, value);
      default:
        return state
    }
  }
}
